import { Container, Nav } from "react-bootstrap"
import Spinner from "../../components/Spinner"

const SkeletonBody = () => {
  return (
    <Container fluid className="p-0 m-0 flex-grow-1 w-100 d-flex">
      {/* Sidebar */}
      <div className="p-0 pt-5 border-end flex-shrink-0 px-3" style={{ width: "260px" }}>
        <Nav className="flex-column">
        </Nav>
      </div>

      {/* Main Content */}
      <div className="p-5 flex-grow-1 position-relative" style={{ backgroundColor: "#f7fafc" }}>
        <Container className="mt-3 p-0 d-flex flex-column align-items-center">
          <Spinner />
        </Container>
      </div>
    </Container>
  )
}

export default SkeletonBody